import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { ChangeLanguage } from "./ChangeLanguage";
import { Twirl as Hamburger } from "hamburger-react";
import logo from "../img/logo2.svg";

export const AppHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const navRef = useRef(null);
  const productsRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (productsRef.current && !productsRef.current.contains(event.target)) {
        setIsProductsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLinkClick = (to) => {
    if (location.pathname !== "/") {
      navigate("/", { replace: true });
      setTimeout(() => {
        const el = document.getElementById(to);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      const el = document.getElementById(to);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="App-header">
      <nav className="nav" ref={navRef}>
        <div className="nav-left">
          <a
            href="/"
            className="logo"
            onClick={(e) => {
              if (location.pathname !== "/") {
                e.preventDefault();
                navigate("/");
              } else {
                handleLinkClick("landing");
              }
            }}
          >
            <img src={logo} alt="Predsense company logo" />
          </a>

          <div className={`nav-links ${isOpen ? "open" : ""}`}>
            <div className="nav-link-dropdown" ref={productsRef}>
              <button
                className="nav-link nav-link-dropdown-btn"
                onClick={() => setIsProductsOpen(!isProductsOpen)}
                onMouseEnter={() => setIsProductsOpen(true)}
              >
                {t("Products")}
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    marginLeft: "6px",
                    transform: isProductsOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                  }}
                >
                  <path d="M6 9L1 4H11L6 9Z" fill="currentColor" />
                </svg>
              </button>
              {isProductsOpen && (
                <div
                  className="nav-dropdown-menu"
                  onMouseLeave={() => setIsProductsOpen(false)}
                >
                  <a
                    className="nav-dropdown-item"
                    href="/products/labeling"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/products/labeling");
                      setIsProductsOpen(false);
                      setIsOpen(false);
                    }}
                  >
                    {t("TimeSeriesLabeling")}
                  </a>
                  <a
                    className="nav-dropdown-item"
                    href="/products/anomaly-detection"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/products/anomaly-detection");
                      setIsProductsOpen(false);
                      setIsOpen(false);
                    }}
                  >
                    {t("AnomalyDetection")}
                  </a>
                </div>
              )}
            </div>
            <a
              className="nav-link"
              href="/pricing"
              onClick={(e) => {
                e.preventDefault();
                navigate("/pricing");
                setIsOpen(false);
              }}
            >
              {t("Pricing")}
            </a>
            <a
              className="nav-link"
              href="/services"
              onClick={(e) => {
                e.preventDefault();
                navigate("/services");
                setIsOpen(false);
              }}
            >
              {t("Services")}
            </a>
            <a
              className="nav-link"
              href="/blog"
              onClick={(e) => {
                e.preventDefault();
                navigate("/blog");
                setIsOpen(false);
              }}
            >
              {t("Blog")}
            </a>
            <a
              className="nav-link"
              href="/about"
              onClick={(e) => {
                e.preventDefault();
                navigate("/about");
                setIsOpen(false);
              }}
            >
              {t("AboutUs")}
            </a>
            {/*<a*/}
            {/*  className="nav-link"*/}
            {/*  href="/"*/}
            {/*  onClick={(e) => {*/}
            {/*    e.preventDefault();*/}
            {/*    navigate("/");*/}
            {/*    setTimeout(() => {*/}
            {/*      const contactSection = document.getElementById("contact");*/}
            {/*      if (contactSection) {*/}
            {/*        contactSection.scrollIntoView({ behavior: "smooth" });*/}
            {/*      }*/}
            {/*    }, 100);*/}
            {/*    setIsOpen(false);*/}
            {/*  }}*/}
            {/*>*/}
            {/*  {t("Contact")}*/}
            {/*</a>*/}
          </div>
        </div>
        <div className="nav-right">
          <ChangeLanguage />
          {/*<a href="https://app.predsense.ai" className="sign-in-btn">
            {t("SignIn")}
          </a>
          <button onClick={handleStartFreeClick} className="start-building-btn">
            {t("StartFree")}
          </button>*/}
          <Hamburger
            className="hamburger"
            toggled={isOpen}
            toggle={setIsOpen}
            size={20}
          />
        </div>
      </nav>
    </header>
  );
};
